// Node Modules
import { nanoid } from 'nanoid';
import React from 'react';

// Components
import Detail from './sub-components/Detail';

// Themes
import theme from '@/themes/index';

export const Details = ({
  isDesktop,
  content, 
}) => {
  const getDetailsForDesktop = () => {
    const detailsList = content.reduce(
      (accumulator, currentValue, i) =>
        (i % 2
          ? accumulator[accumulator.length - 1].push(currentValue.detail)
          : accumulator.push([currentValue.detail])) && accumulator,
      []
    );
    return (
      <>
        {detailsList.map((details, index) => (
          <React.Fragment key={nanoid()}>
            <div key={nanoid()} className='desktop-details-container'>
              {details.map(detail => (
                <Detail key={nanoid()} content={detail} />
              ))}
            </div>
            {index + 1 !== detailsList.length && <hr />}
          </React.Fragment>
        ))}
        <style jsx>{`
          .desktop-details-container {
            display: flex;
            flex-direction: row;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            .desktop-details-container {
              gap: 2.4rem;
            }

            hr {
              width: 100%;
              margin: 4rem 0;
            }
          }
        `}</style>
      </>
    );
  };

  const getDetailsForMobile = () => {
    return (
      <>
        {content.map(item => (
          <Detail key={nanoid()} content={item.detail} />
        ))}
      </>
    );
  };

  return (
    <>
      <div className='main-container'>
        {!isDesktop ? getDetailsForMobile() : getDetailsForDesktop()}
      </div>
      <style jsx>{`
        .main-container {
          display: flex;
          flex-direction: column;
          gap: 2rem;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          .main-container {
            gap: 0;
          }
        }
      `}</style>
    </>
  );
};

export default Details;
